import { useMediaQuery } from "@mui/material";

export const useIsMobileView = () => {
  const mobileWidth = useMediaQuery("(max-width: 850px)", { noSsr: true });
  const mobileHeight = useMediaQuery("(max-height: 650px)", { noSsr: true });

  return mobileWidth || mobileHeight;
};
